import { render, staticRenderFns } from "./DocGerenciarPermissoes.vue?vue&type=template&id=fe7eec48&scoped=true"
import script from "./DocGerenciarPermissoes.vue?vue&type=script&lang=js"
export * from "./DocGerenciarPermissoes.vue?vue&type=script&lang=js"
import style0 from "./DocGerenciarPermissoes.vue?vue&type=style&index=0&id=fe7eec48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe7eec48",
  null
  
)

export default component.exports